// Suggest a relevant Free Tool calculator based on a question's wording.
// Order matters — first match wins.
const MAP = [
  [/\b(bmi|body mass index)\b/i, "bmi"],
  [/\b(waist)\b/i, "waist-height-ratio"],
  [/\b(ideal\s+(body\s+)?weight)\b/i, "ideal-body-weight"],
  [/\b(a1c|hba1c|hemoglobin\s+a1c|glycated)\b/i, "a1c-to-glucose"],
  [/\b(blood\s+pressure|hypertension|systolic|diastolic)\b/i, "blood-pressure"],
  [/\b(creatinine\s+clearance|cockcroft)\b/i, "creatinine-clearance"],
  [/\b(egfr|gfr|kidney\s+function)\b/i, "egfr"],
  [/\b(non[-\s]?hdl)\b/i, "non-hdl"],
  [/\b(ldl)\b/i, "ldl"],
  [/\b(cholesterol|lipid)\b/i, "cholesterol-risk"],
  [/\b(target\s+heart\s+rate|heart\s+rate\s+zone|exercise\s+heart\s+rate)\b/i, "target-heart-rate"],
  [/\b(due\s+date|how\s+far\s+along|gestational|pregnan)\b/i, "due-date"],
  [/\b(fever|acetaminophen|tylenol|ibuprofen|motrin|advil).{0,30}(child|kid|baby|infant|toddler)|\b(child|kid|baby|infant|toddler).{0,30}(fever|acetaminophen|tylenol|ibuprofen|motrin|advil)/i, "pediatric-fever"],
];

export function matchTool(question) {
  const q = (question || "").toLowerCase();
  if (!q) return null;
  for (const [re, slug] of MAP) if (re.test(q)) return slug;
  return null;
}
